import $ from 'jquery';

// AskFelix Main Application Entry Point
import './shared.js';
import './simpleauth.js';
import './data-accessor.js';
import './query-fix.js';
import './frontend-error-monitor.js';
import './performance-monitor.js';
import './autocomplete.js';
import './query-history.js';
import './treeview.js';
import './router.js';
import './file-upload.js';
import './grids.js';
import './chats.js';
import './dataset-editor.js';
import './dataset-publish.js';
import './datasets.js';
import './views/templates.js';
import './views/views.js';
import './datadisplay.js';
import './dashboarding.js';
import './snacks.js';
import './graph-utils.js';
import './d3-renderer.js';
import './graph-cache.js';
import './graph-memory-manager.js';
import './graph-sharing.js';
import './data-connectors.js';
import './data-sources.js';
import './usage-tracking.js';
import './account.js';
import './admin.js';
import './sheets-page.js';
import './chart-controls.js';

// Initialize the app when DOM is ready
if (typeof window !== 'undefined') {
  const initApp = () => {
    console.log('🚀 AskFelix App initialized');

    document.querySelectorAll('[data-agent-prompt]').forEach(button => {
      button.addEventListener('click', () => {
        const queryInput = document.getElementById('query');
        if (!queryInput) return;
        queryInput.value = button.getAttribute('data-agent-prompt') || '';
        queryInput.dispatchEvent(new Event('input', { bubbles: true }));
        queryInput.focus();
        queryInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    // Initialize router if available
    if (window.AppRouter) {
      window.appRouter = new window.AppRouter();
      if (typeof window.__helixStartBackboneHistory === 'function') {
        window.__helixStartBackboneHistory('src/js/app.js');
      } else if (
        typeof Backbone !== 'undefined' &&
        Backbone.history &&
        !Backbone.history.started &&
        !window.__helixBackboneHistoryStarted
      ) {
        try {
          window.__helixBackboneHistoryStarted = true;
          Backbone.history.start({ pushState: true });
        } catch (error) {
          var message = error && error.message ? String(error.message) : '';
          if (!/already been started/i.test(message)) {
            window.__helixBackboneHistoryStarted = false;
            throw error;
          }
        }
      }
    }

    // Initialize auth if available
    if (window.SimpleAuth) {
      window.auth = window.SimpleAuth;
    }

    // Trigger app ready event
    if (typeof $ !== 'undefined') {
      $(document).trigger('askfelix:ready');
    }
  };

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }
}

export default {
  version: '1.0.0',
  buildTime: typeof BUILD_TIME !== 'undefined' ? BUILD_TIME : new Date().toISOString()
};
